import React from "react";
import { Navigate, Params, Route, Routes } from "react-router-dom";
import { observer } from "mobx-react";
import PurchaseLinkDetailPage from "./PurchaseLinkDetailPage";
import { Loader, UtilityMethods, withRouter } from "@mindmemobile/mm-shared-global";
import {
  ItemsStore,
  PurchaseLinkStore,
  PurchaseStore,
  RolesAndPermissionStore,
} from "../../../shared/store";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

interface IProps {
  itemStore: ItemsStore;
  params: Readonly<Params<string>>;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
}

const purchaseLinkStore = new PurchaseLinkStore();
const purchaseStore = new PurchaseStore();

const PurchaseLinkRoutes: React.FC<IProps> = ({
  params,
  itemStore,
  merchantAccountStore,
  rolesAndPermissionStore,
}) => {
  function purchaseLinkId() {
    const split = ((params && params["*"]) || "").split("/");
    const id = split[split.length - 1];
    if (UtilityMethods.isValidObjectId(id)) {
      return id;
    }
    return "";
  }
  if (!itemStore.countryStore.countryDataLoaded) {
    return <>{new Loader().loaderComponent}</>;
  }
  return (
    <Routes>
      <Route
        path={`/detail/:id`}
        element={
          <PurchaseLinkDetailPage
            id={purchaseLinkId()}
            purchaseLinkStore={purchaseLinkStore}
            itemStore={itemStore}
            purchaseStore={purchaseStore}
            merchantAccountStore={merchantAccountStore}
            rolesAndPermissionStore={rolesAndPermissionStore}
          />
        }
      />
      <Route path="*" element={<Navigate to="/items" />} />
    </Routes>
  );
};
export default withRouter(observer(PurchaseLinkRoutes));
